import styled from "styled-components";
import { MainHeading, MainSectionWrapper } from "../../../../components/01_config/MainStyles";

const WrapperSection = styled(MainSectionWrapper)`
`

const HeadingSection = styled(MainHeading)`
    text-align: center;
`




export { WrapperSection, HeadingSection }
